import React from "react";
import { WqSwal as Swal } from "../../utils/themedSwal";
import Frame from 'react-frame-component';
// downgraded react frame component library from the one below
// "react-frame-component": "^5.2.6",
import { BoldText } from "../normalText/normalText";
import styles from "./normal.module.css";
import { InputText } from "../inputs/inputs";
import { Dispatach_Card_Navigation } from "../../redux/actions/navigations";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { useEffect, useState } from "react";
import config from '../../config.js';
import axios from "axios";
import { toast } from "react-hot-toast";
import { hideLoader, showLoader } from "../../utils/loader";
import Tiframe from "./iFrame";
import { CancelButton } from "../button/button";
import { getEmbedContext, notifyParent } from "../../utils/embed.js";
import { finalizePaymentSuccess } from "../../utils/paymentOutcomes.js";



export const Four = ({ action, getPin, setSupportMessage, setOtpMessage, setPaymentId, publicKey }) => {
  const [tDData, set3dData] = useState([]);
  const [show3D, setShow3D] = useState(false);
  const input_1 = useRef();
  const input_2 = useRef();
  const input_3 = useRef();
  const input_4 = useRef();

  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [input3, setInput3] = useState('');
  const [input4, setInput4] = useState('');
  const { isEmbedded } = getEmbedContext();
  const Dispatch = useDispatch();
  const isTestMode = (publicKey).includes("_TEST_");

  useEffect(() => {
    input_1.current.focus();
  }, []);

  useEffect(() => {
    const pin = `${input1}${input2}${input3}${input4}`;
    getPin(pin);
    if (pin.length === 4) {
      if (!isNaN(pin) && !isNaN(parseFloat(pin))) {
        Authourize(pin);
      }
    }
  }, [input1, input2, input3, input4]);

  const handleOnInput = (e, setter, nextInput) => {
    const val = e.target.value.substring(0, 1);
    setter(val);
    if (val.length === 1 && nextInput) {
      nextInput.current.focus();
    }
  };

  /*
    The gateway can return an OTP challenge (responseCode / status "10") with a
    NON-2xx HTTP code and a top-level "status": false. Axios rejects on that, so
    routing must be driven by the response BODY, not by whether the promise
    settled fulfilled or rejected. This function inspects a body and performs the
    right navigation. It returns true when it handled the body, false when the
    caller should surface an error.
  */
  const routeAuthResponse = (body, tranId) => {
    const d = body?.data;
    if (!d) return false;

    // Backend has sent both strings and numbers here; normalise before compare.
    const code = String(d?.responseCode ?? "");
    const stat = String(d?.status ?? "");
   
    // ---- Approved ----
    if (code === "00") {
      // Swal.fire({
      //   title: "Success",
      //   text: `${d?.message}`,
      //   icon: "success",
      //   confirmButtonText: "Ok",
      //   timer: 10000,
      //   timerProgressBar: true
      // }).then(() => {
      //   const callback = sessionStorage.getItem("fallbackUrl");
      //   const referrer = sessionStorage.getItem("referrer");

      //   const isBadReferrer =
      //     referrer?.includes("payment-link") || referrer?.includes("_tranId");

      //   let redirectUrl;

      //   if (callback) {
      //     redirectUrl = callback;
      //   } else if (referrer && !isBadReferrer) {
      //     redirectUrl = referrer;
      //   } else {
      //     redirectUrl = "https://wayaquick.com";
      //   }
        
      //   if (isEmbedded) {
      //     sessionStorage.clear();
      //     notifyParent("success");
      //     return;
      //   }

      //   sessionStorage.setItem("paymentCompleted", "true");
      //   const completedFlag = sessionStorage.getItem("paymentCompleted");
      //   sessionStorage.clear();
      //   sessionStorage.setItem("paymentCompleted", completedFlag);
      //   const isPopup = window.opener && !window.opener.closed;
      //   if (isPopup) {
      //     window.opener.postMessage(
      //       {
      //         type: "PAYMENT_SUCCESS",
      //         tranId: tranId,
      //       },
      //       "*"
      //     );
      //     window.close();
      //   } else {
      //     window.location.replace(redirectUrl);
      //   }
      // });
      finalizePaymentSuccess({ message: d?.message, tranId, isEmbedded });
      return true;
    }

    // --- test mode ---

    if (isTestMode) {
      // Swal.fire({
      //   title: "Success",
      //   text: `${"Successful test payment on card"}`,
      //   icon: "success",
      //   confirmButtonText: "Ok",
      //   timer: 10000,
      //   timerProgressBar: true
      // }).then(() => {
      //   const callback = sessionStorage.getItem("fallbackUrl");
      //   const referrer = sessionStorage.getItem("referrer");

      //   const isBadReferrer =
      //     referrer?.includes("payment-link") || referrer?.includes("_tranId");

      //   let redirectUrl;

      //   if (callback) {
      //     redirectUrl = callback;
      //   } else if (referrer && !isBadReferrer) {
      //     redirectUrl = referrer;
      //   } else {
      //     redirectUrl = "https://wayaquick.com";
      //   }
        
      //   if (isEmbedded) {
      //     sessionStorage.clear();
      //     notifyParent("success");
      //     return;
      //   }

      //   sessionStorage.setItem("paymentCompleted", "true");
      //   const completedFlag = sessionStorage.getItem("paymentCompleted");
      //   sessionStorage.clear();
      //   sessionStorage.setItem("paymentCompleted", completedFlag);
      //   const isPopup = window.opener && !window.opener.closed;
      //   if (isPopup) {
      //     window.opener.postMessage(
      //       {
      //         type: "PAYMENT_SUCCESS",
      //         tranId: tranId,
      //       },
      //       "*"
      //     );
      //     window.close();
      //   } else {
      //     window.location.replace(redirectUrl);
      //   }
      // });
      finalizePaymentSuccess({
        message: "Successful Test payment on card",
        tranId,
        isEmbedded,
        notifyExtra: { simulated: true },
      });
      return true;
    }

    // ---- OTP challenge ----
    // Checked BEFORE the error fallback and against both fields, because the
    // gateway populates status:"10" and responseCode:"10" inconsistently.
    if (stat === "10" || code === "10") {
      // The payload carries paymentId, not authTransactionId. Fall back through
      // the plausible ids rather than silently passing undefined to the OTP page.
      setPaymentId(d?.paymentId ?? d?.authTransactionId ?? d?.transactionId);
      // plainTextSupportMessage is absent on this payload; message is the copy
      // that actually names the masked phone number.
      setSupportMessage(d?.plainTextSupportMessage ?? d?.message ?? body?.message);
      setOtpMessage(d?.message ?? body?.message);
      Dispatach_Card_Navigation(Dispatch, 4);
      return true;
    }

    // ---- 3DS / redirect ----
    if (code === "12") {
      if (d?.processor === "UP") {
        window.open(d?.url, '_self');
      } else {
        set3dData(d);
        setShow3D(true);
      }
      return true;
    }

    if (code === "S0") {
      set3dData(d);
      setShow3D(true);
      return true;
    }

    return false;
  };

  const showAuthError = (message) => {
    Swal.fire({
      title: "Error",
      text: message || "An error occurred, please try again later",
      icon: "error",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
    }).then(() => {
      if (sessionStorage.getItem("referrer")) {
        window.location.href = sessionStorage.getItem("referrer");
      } else {
        window.history.go(-1);
      }
    });
  };

  const Authourize = (pin) => {
    showLoader();
    const tranId = sessionStorage.getItem("tranId");

    const paymentData = {
      "mode": process.env.mode,
      "pin": pin,
      "transactionId": tranId
    }

    const API_ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/transaction/authorization`;

    /*
      Two-argument .then(onFulfilled, onRejected) instead of .then().catch().
      With .catch() chained after .then(), any exception thrown INSIDE the success
      handler (a missing prop, a bad setter) lands in the same catch as a network
      failure and masquerades as an API error. Splitting them keeps real bugs loud.
    */
    axios.post(API_ENDPOINT, paymentData).then(
      (response) => {
        hideLoader();
        const handled = routeAuthResponse(response?.data, tranId);
        if (!handled) {
          showAuthError(response?.data?.message);
        }
      },
      (error) => {
        hideLoader();

        // A rejected promise does NOT mean the transaction failed. The OTP
        // challenge arrives here when the gateway pairs it with a 4xx.
        const body = error?.response?.data;
        if (body && routeAuthResponse(body, tranId)) {
          return;
        }

        toast.error("Error!");
        showAuthError(
          body?.message || body?.description || error?.message
        );
      }
    ).catch((handlerError) => {
      // Only reached if routeAuthResponse / showAuthError itself threw. This is
      // a front-end bug, not an API failure, so log it loudly instead of
      // dressing it up as a payment error.
      hideLoader();
      console.error("Authorization handler crashed:", handlerError);
    });
  }

  const Auth3d = () => {
    //setLoading(true);
    showLoader();
    const tranId = sessionStorage.getItem("tranId");
    const cardEncrypt = sessionStorage.getItem("cardEncrypt");

  
    const cancelData = {
      "cardEncrypt": cardEncrypt,
      "otp": null,
      "tranId": tranId
    }
    const API_ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/transaction/processing`;
    axios.post(API_ENDPOINT, cancelData).then(response => {
      sessionStorage.setItem("expired", true);
      // sessionStorage.removeItem("tranId");
      // sessionStorage.removeItem("product_data");
      hideLoader()
      Swal.fire({
        title: "Success",
        text: `${response?.data?.message}`,
        icon: "success",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          const callback = window.sessionStorage.getItem("fallbackUrl")
          sessionStorage.clear();
          if (typeof(callback) !== 'undefined' && callback != null){
            window.location.href= callback;
          }
          else{
            if (sessionStorage.getItem('referrer')) {
              window.location.href(sessionStorage.getItem('referrer'));
            } else {
              window.history.go(-3);
            }
            //  window.history.go(-1);
          }
        }
      });
    }).catch(error => {
      hideLoader();
      //setErrMsg(error.response.data.message);
      //console.log(error)
    });

  }

  return (
    <div className={`${styles.container}`}>
       {
        !show3D ? 
        <>
        <BoldText align={"center"}>
            Kindly provide your 4-digit card pin to authorize this payment
        </BoldText>
        <div className={`${styles.boxContainer}`}>
          
        <InputText type="password" maxlength="1" reference={input_1} onInput={(e) => handleOnInput(e, setInput1, input_2)} value={input1} />
        <InputText type="password" maxlength="1" reference={input_2} onInput={(e) => handleOnInput(e, setInput2, input_3)} value={input2} />
        <InputText type="password" maxlength="1" reference={input_3} onInput={(e) => handleOnInput(e, setInput3, input_4)} value={input3} />
        <InputText type="password" maxlength="1" reference={input_4} onInput={(e) => handleOnInput(e, setInput4, null)} value={input4} />
      </div>
      {/* todo uncomment out after initiating transaction status for expired transactions so user can go back only if transaction is still active */}
      {/* <CancelButton text="cancel" onClick={() => Dispatach_Card_Navigation(Dispatch, 1)} /> */}
      </>   
      : <>
      <Frame style={{ height: 500 }} >        
     <Tiframe 
           tDData={tDData}
           showModal={show3D}
           hideModal={setShow3D}
           /> 
      </Frame>
      <CancelButton text="continue" onClick={Auth3d} />
      </>
      }
    </div>
  );
};
